import * as actionTypes from './actionTypes'

const getRuleList = filter => ({
    type: actionTypes.GET_RULE_LIST_REQUEST,
    filter
});

const searchRules = searchFields => ({
    type: actionTypes.RULE_SEARCH_REQUEST,
    searchFields
});

const getRuleData = ruleId => ({
    type: actionTypes.GET_RULE_REQUEST,
    ruleId
});

const createRule = ruleData => ({
    type: actionTypes.CREATE_RULE_REQUEST,
    ruleData
});

const editRule = (ruleId, ruleData) => ({
    type: actionTypes.EDIT_RULE_REQUEST,
    ruleId,
    ruleData
});

const deleteRule = ruleId => ({
    type: actionTypes.DELETE_RULE_REQUEST,
    ruleId
});


export default {
    getRuleList,
    searchRules,
    getRuleData,
    createRule,
    editRule,
    deleteRule,
}